module.exports = __webpack_public_path__ + "img/logo-drawThings.1c043938.png";